const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type JobAnalyticsEvent = 'view' | 'apply';

export async function recordJobAnalytics(jobId: string | number, event: JobAnalyticsEvent) {
  if (!API_BASE_URL) return;
  if (!jobId) return;
  try {
    const response = await fetch(`${API_BASE_URL}/v1/job-analytics/${jobId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event }),
    });
    if (!response.ok) {
      const text = await response.text().catch(() => 'request failed');
      throw new Error(`Job analytics request failed (${response.status}): ${text}`);
    }
  } catch (error) {
    console.warn('[job-analytics] failed to record event', error);
  }
}

export type JobAnalyticsRow = {
  jobId: string;
  title: string;
  views: number;
  applies: number;
  lastViewAt: string | null;
  lastApplyAt: string | null;
  occupationId?: string | null;
  occupationTitle?: string | null;
};

export async function fetchJobAnalytics(occupationId?: string): Promise<JobAnalyticsRow[]> {
  if (!API_BASE_URL) return [];
  const url = new URL(`${API_BASE_URL}/v1/job-analytics`);
  if (occupationId) url.searchParams.set('occupationId', occupationId);
  const response = await fetch(url.toString(), { headers: { 'Content-Type': 'application/json' } });
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Job analytics fetch failed (${response.status}): ${text}`);
  }
  const payload = await response.json();
  if (Array.isArray(payload?.jobs)) {
    return payload.jobs as JobAnalyticsRow[];
  }
  return [];
}
